import { BooleanControl } from '@components/uploadForm/renderers/views/BooleanControl';
import { BooleanToggleControl } from '@components/uploadForm/renderers/views/BooleanToggleControl';
import { NativeControl } from '@components/uploadForm/renderers/views/NativeControl';
import {
  NumberControl,
  OneOfEnumControl,
  TextControl,
} from '@components/uploadForm/renderers/views/InputControl';
import { RadioGroupControl } from '@components/uploadForm/renderers/views/RadioGroupControl';
import { GroupLayoutRenderer } from '@components/uploadForm/renderers/views/layouts/GroupLayout';
import { HorizontalLayoutRenderer } from '@components/uploadForm/renderers/views/layouts/HorizontalLayout';
import { VerticalLayoutRenderer } from '@components/uploadForm/renderers/views/layouts/VerticalLayout';
import { LabelRenderer } from '@components/uploadForm/renderers/views/Label';
import {
  withJsonFormsControlProps,
  withJsonFormsEnumProps,
  withJsonFormsLayoutProps,
  withJsonFormsOneOfEnumProps,
} from '@jsonforms/react';

import { JsonFormDatePicker } from '@components/uploadForm/renderers/views/DatePicker';
import { GroupRenderer } from '@components/uploadForm/renderers/views/layouts/GroupRenderer';

/** Add here all the renders for UI **/

export const uploadControlConfigurationRenderer = [
  {
    component: withJsonFormsControlProps(BooleanControl),
    tester: 'BooleanControl',
  },
  {
    component: withJsonFormsControlProps(BooleanToggleControl),
    tester: 'BooleanToggle',
  },
  {
    component: withJsonFormsControlProps(NativeControl),
    tester: 'NativeControl',
  },
  {
    component: withJsonFormsEnumProps(OneOfEnumControl),
    tester: 'EnumControl',
  },
  {
    component: withJsonFormsControlProps(NumberControl),
    tester: 'IntegerControl',
  },
  {
    component: withJsonFormsControlProps(NumberControl),
    tester: 'NumberControl',
  },
  {
    component: withJsonFormsControlProps(TextControl),
    tester: 'TextControl',
  },
  {
    component: withJsonFormsControlProps(JsonFormDatePicker),
    tester: 'DateTimeControl',
  },
  {
    component: withJsonFormsControlProps(JsonFormDatePicker),
    tester: 'DateControl',
  },
  {
    component: withJsonFormsEnumProps(RadioGroupControl),
    tester: 'RadioGroupControl',
  },
  {
    component: withJsonFormsOneOfEnumProps(RadioGroupControl),
    tester: 'OneOfRadioGroupControl',
  },
  {
    component: withJsonFormsOneOfEnumProps(OneOfEnumControl),
    tester: 'OneOfEnumControl',
  },

  //layouts
  {
    component: withJsonFormsLayoutProps(GroupLayoutRenderer),
    tester: 'GroupLayout',
  },
  {
    component: withJsonFormsLayoutProps(HorizontalLayoutRenderer),
    tester: 'HorizontalLayout',
  },
  {
    component: withJsonFormsLayoutProps(VerticalLayoutRenderer),
    tester: 'VerticalLayout',
  },
  {
    component: withJsonFormsLayoutProps(LabelRenderer),
    tester: 'LabelRenderer',
  },
  {
    component: withJsonFormsLayoutProps(GroupRenderer),
    tester: 'GroupRenderer',
  },
];
